import { ManageActionPanel } from "@/overlay/components/LayerStackWindow/ManageActionPanel/ManageActionPanel";
import { useAppDispatch } from "@/reducer";
import { pasteWeatherTable } from "@/reducer/WeatherTablesState";
import type { WeatherTable } from "@/weatherTableView/types";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import { BufferName, useLocalClipboard } from "../ManageActionPanel/LocalClipboardContext";

type WeatherTableActionPanelProps = {
  table: WeatherTable;
  clearWeatherTable: () => void;
};

type WeatherTableActionData = WeatherTable["groups"];

function WeatherTableActionPanel({ table, clearWeatherTable }: WeatherTableActionPanelProps) {
  const dispatch = useAppDispatch();

  const { readData, storeData, hasData } = useLocalClipboard<WeatherTableActionData>();

  const hasColumns = useMemo(() => table.groups.some((g) => !isEmpty(g.columns)), [table]);

  function copyTableGroups() {
    storeData(BufferName.WeatherTableGroups, table.groups);
  }

  function replaceTable() {
    const copiedTableGroups = readData(BufferName.WeatherTableGroups);
    dispatch(
      pasteWeatherTable({
        id: table.id,
        weatherTableGroups: copiedTableGroups,
      }),
    );
  }

  return (
    <ManageActionPanel
      onCopy={copyTableGroups}
      onReplace={replaceTable}
      onRemove={clearWeatherTable}
      pastDisabled={!hasData(BufferName.WeatherTableGroups)}
      disabled={!hasColumns}
    />
  );
}

export { WeatherTableActionPanel };
